import { NgModule } from '@angular/core';
import { AuthGuardService } from 'app/shared/auth-guard.service';
import { EntityManagerProviderGuard } from 'app/shared/entity-manager-guard';

import { canDeactivateGuard } from 'app/shared/can-deactivate-guard.service';
import { MarkdownModule } from 'ngx-markdown';
import { SharedModule } from 'app/shared/shared.module';
import { AddonBinProcessComponent } from './addon-bin-process.component';
import { AddonBinSetPriorityDialogComponent } from './addon-bin-set-priority-dialog.component';
import { AddonBinSplitDialogComponent } from './addon-bin-split-dialog.component';
import { AddonBinComponent } from './addon-bin.component';
import { AddonWipComponent } from './addon-wip.component';
import { AskShipInfoDialogComponent } from './ask-ship-info-dialog.component';
import { ChangeJoPullBatchDialogComponent } from './change-jo-pull-batch-dialog.component';
import { EventScheduleDialogComponent } from './event-schedule-dialog.component';

import { JoAuditComponent } from './jo-audit.component';
import { JoInProcessComponent } from './jo-in-process.component';
import { JobOrderInfoComponent } from './jo-info.component';
import { JoInvoiceComponent } from './jo-invoice.component';
import { JoPullApplyComponent } from './jo-pull-apply.component';
import { JoPullToWipComponent } from './jo-pull-to-wip.component';
import { JoReturnRequestComponent } from './jo-return-request.component';
import { JoShipPrepScanDialog } from './jo-ship-prep-scan-dialog.component';
import { JoShipPrepComponent } from './jo-ship-prep.component';
import { JoShipScanDialog } from './jo-ship-scan-dialog.component';
import { JoShipComponent } from './jo-ship.component';
import { JobOrdersComponent } from './job-orders.component';
import { ManifestPrintDialogComponent } from './manifest-print-dialog.component';
import { ManifestComponent } from './manifest.component';
import { PrintableJoWipComponent } from './OLD/printable-jo-wip.component';
import { PrintableInvoiceContentComponent } from './printable-invoice-content.component';
import { PrintableInvoiceComponent } from './printable-invoice.component';
import { PrintableManifestComponent } from './printable-manifest.component';
import { ReturnRequestDetailDialogComponent } from './return-request-detail-dialog.component';
import { ReceiveRrdDialogComponent } from './receive-rrd-dialog.component';
import { InspectRrdDialogComponent } from './inspect-rrd-dialog.component';
import { RouteRrdDialogComponent } from './route-rrd-dialog.component';
import { SettleRrdDialogComponent } from './settle-rrd-dialog.component';
import { ReconcileRrdDialogComponent } from './reconcile-rrd-dialog.component';
import { RecoverRrdDialogComponent } from './recover-rrd-dialog.component';
import { ReturnsInboxComponent } from './returns-inbox.component';
import { ShipFrequencyDialogComponent } from './ship-frequency-dialog.component';
import { UnapplyJodDialogComponent } from './unapply-jod-dialog.component';
import { FreightExplanationDialogComponent } from './freight-explanation-dialog.component';
import { ExplainJobOrderDialogComponent } from './explain-job-order-dialog.component';
import { FreightEntryDialogComponent } from './freight-entry-dialog.component';
import { BatchSummaryDialogComponent } from './batch-summary-dialog.component';
import { PrintableOpenJoDetailComponent } from './printable-open-jo-detail.component';
import { PrintablePackingSlipComponent } from './printable-packing-slip.component';
import { PackingSlipPrintDialogComponent } from './packing-slip-print-dialog.component';
import { ProcessManagerComponent } from './process-manager.component';
import { ScanStationComponent } from './scan-station.component';
import { ShipBinAddonDialogComponent } from './ship-bin-addon-dialog.component';
import { ShipBinCheckoutDialogComponent } from './ship-bin-checkout-dialog.component';
import { ShipBinManagementComponent } from './ship-bin-management.component';
import { AcctOwnedInvoicesComponent } from './acct-owned-invoices.component';
import { EndOfDayComponent } from './end-of-day.component';
import { EndOfDayDocComponent } from './end-of-day-doc.component';
import { EndOfDayManagerComponent } from './end-of-day-manager.component';
import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'in-process',
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        redirectTo: 'manage',
        pathMatch: 'full',
      },
      {
        path: 'manage',
        canActivate: [AuthGuardService],
        component: ProcessManagerComponent,
        data: { breadcrumb: 'In-Process' },
        children: [
          {
            path: '',
            redirectTo: 'job-orders',
            pathMatch: 'full',
          },
          {
            path: 'job-orders',
            canActivate: [AuthGuardService, EntityManagerProviderGuard],
            canDeactivate: [canDeactivateGuard],
            component: JobOrdersComponent,
            data: { breadcrumb: 'Job Orders' },
          },
          {
            path: 'jo-invoice/:joHeaderId/:invoiceId',
            component: JoInvoiceComponent,
            canActivate: [AuthGuardService, EntityManagerProviderGuard],
            canDeactivate: [canDeactivateGuard],
            data: { breadcrumb: 'Invoice' },
          },
          {
            path: 'jo-in-process',
            canActivate: [AuthGuardService, EntityManagerProviderGuard],
            canDeactivate: [canDeactivateGuard],
            component: JoInProcessComponent,
            data: { breadcrumb: 'In-Process' },
          },
          {
            path: 'addon-bins',
            canActivate: [AuthGuardService, EntityManagerProviderGuard],
            canDeactivate: [canDeactivateGuard],
            component: AddonBinComponent,
            data: { breadcrumb: 'Process Bins' },
          },
          {
            path: 'addon-bin/:addonBinId',
            component: AddonBinProcessComponent,
            canActivate: [AuthGuardService, EntityManagerProviderGuard],
            data: { breadcrumb: 'Process Bin' },
          },
          {
            path: 'scan-station',
            canActivate: [AuthGuardService, EntityManagerProviderGuard],
            canDeactivate: [canDeactivateGuard],
            component: ScanStationComponent,
            data: { breadcrumb: 'Ship Prep' },
          },
          // {
          //   path: "jo-ship-prep",
          //   canActivate: [AuthGuardService, EntityManagerProviderGuard],
          //   canDeactivate: [canDeactivateGuard],
          //   component: JoShipPrepComponent,
          //   data: { breadcrumb: "Ship Prep" },
          // },
          {
            path: 'ship-bins',
            canActivate: [AuthGuardService, EntityManagerProviderGuard],
            canDeactivate: [canDeactivateGuard],
            component: ShipBinManagementComponent,
            data: { breadcrumb: 'Staging and Vouchering' },
          },
          {
            path: 'jo-ship',
            canActivate: [AuthGuardService, EntityManagerProviderGuard],
            canDeactivate: [canDeactivateGuard],
            component: JoShipComponent,
            data: { breadcrumb: 'Shipping' },
          },
          {
            path: 'jo-pull-to-wip/:joPullBatchId',
            component: JoPullToWipComponent,
            canActivate: [AuthGuardService, EntityManagerProviderGuard],
            canDeactivate: [canDeactivateGuard],
            data: { breadcrumb: 'Pull to WIP' },
          },
          {
            path: 'jo-pull-apply/:joPullBatchId/:joDetailId/:shouldPrintBarcodes',
            component: JoPullApplyComponent,
            canActivate: [AuthGuardService, EntityManagerProviderGuard],
            canDeactivate: [canDeactivateGuard],
            data: { breadcrumb: 'Pull Apply' },
          },
          {
            path: 'jo-audit',
            component: JoAuditComponent,
            canActivate: [AuthGuardService, EntityManagerProviderGuard],
            canDeactivate: [canDeactivateGuard],
            data: { title: 'Integrity Audits', breadcrumb: 'Integrity Audits' },
          },
        ],
      },
    ],
  },
  {
    path: 'end-of-day',
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        redirectTo: 'manage',
        pathMatch: 'full',
      },
      {
        path: 'manage',
        component: EndOfDayManagerComponent,
        data: { breadcrumb: 'End of Day' },
        children: [
          {
            path: '',
            redirectTo: 'invoices',
            pathMatch: 'full',
          },
          {
            path: 'invoices',
            canActivate: [AuthGuardService, EntityManagerProviderGuard],
            component: EndOfDayComponent,
            data: { breadcrumb: 'Print/Post Invoices' },
          },
          {
            path: 'acct-owned-invoices',
            canActivate: [AuthGuardService, EntityManagerProviderGuard],
            component: AcctOwnedInvoicesComponent,
            data: { breadcrumb: 'Account-Owned Invoices' },
          },
          {
            path: 'manifests',
            canActivate: [AuthGuardService, EntityManagerProviderGuard],
            component: ManifestComponent,
            data: { breadcrumb: 'Manifests' },
          },
          {
            path: 'documentation',
            canActivate: [AuthGuardService],
            component: EndOfDayDocComponent,
            data: { breadcrumb: 'Documentation' },
          },
        ],
      },
    ],
  },
  {
    path: 'printable-invoice/:invoiceId',
    component: PrintableInvoiceComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
    data: { title: 'Printable Invoice' },
  },
  {
    path: 'printable-packing-slip/:invoiceId',
    component: PrintablePackingSlipComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
    data: { title: 'Printable Packing Slip' },
  },
  {
    path: 'printable-manifest/:manifestId',
    component: PrintableManifestComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
    data: { title: 'Printable Manifest' },
  },
  {
    path: 'printable-manifest-group/:manifestGroupId',
    component: PrintableManifestComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
    data: { title: 'Printable Manifest' },
  },
  {
    path: 'printable-open-jo-detail',
    component: PrintableOpenJoDetailComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
    data: { title: 'Open Job Order Detail Report' },
  },
  {
    path: 'returns-inbox',
    component: ReturnsInboxComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
    data: { title: 'Returns' },
  },
  {
    path: 'manifests',
    component: ManifestComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
    data: { title: 'Manifests' },
  },
  {
    path: 'addons-wip',
    component: AddonWipComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
    data: { title: 'Addon Work In Progress' },
  },
  // {
  //   path: "addon-bin/:addonBinId",
  //   component: AddonBinProcessComponent,
  //   canActivate: [AuthGuardService, EntityManagerProviderGuard],
  //   data: { title: "Addon Bin Process" },
  // },
];
routes.forEach((r: any) => {
  r.data = Object.assign(r.data ?? {}, { icon: 'assignment' });
});

@NgModule({
  declarations: [
    JobOrdersComponent,
    JoPullToWipComponent,
    JoPullApplyComponent,
    JoInProcessComponent,
    JoShipPrepComponent,
    JoShipScanDialog,
    JoShipPrepScanDialog,
    JoInvoiceComponent,
    JoShipComponent,
    JoAuditComponent,
    JoReturnRequestComponent,
    ChangeJoPullBatchDialogComponent,
    AskShipInfoDialogComponent,
    EventScheduleDialogComponent,
    ManifestComponent,
    ManifestPrintDialogComponent,
    PrintableInvoiceComponent,
    PrintableInvoiceContentComponent,
    PrintableManifestComponent,
    PrintableJoWipComponent,
    ReturnRequestDetailDialogComponent,
    ReceiveRrdDialogComponent,
    InspectRrdDialogComponent,
    RouteRrdDialogComponent,
    SettleRrdDialogComponent,
    ReconcileRrdDialogComponent,
    RecoverRrdDialogComponent,
    ReturnsInboxComponent,
    UnapplyJodDialogComponent,
    AddonWipComponent,
    AddonBinComponent,
    AddonBinProcessComponent,
    AddonBinSetPriorityDialogComponent,
    AddonBinSplitDialogComponent,
    ShipFrequencyDialogComponent,
    FreightExplanationDialogComponent,
    ExplainJobOrderDialogComponent,
    FreightEntryDialogComponent,
    BatchSummaryDialogComponent,
    JobOrderInfoComponent,
    PrintableOpenJoDetailComponent,
    PrintablePackingSlipComponent,
    PackingSlipPrintDialogComponent,
    ProcessManagerComponent,
    ScanStationComponent,
    ShipBinAddonDialogComponent,
    ShipBinCheckoutDialogComponent,
    ShipBinManagementComponent,
    AcctOwnedInvoicesComponent,
    EndOfDayComponent,
    EndOfDayDocComponent,
    EndOfDayManagerComponent,
  ],
  imports: [SharedModule, MarkdownModule.forChild()],
})
export class JobOrdersModule {}
